import React, { useEffect, useState } from 'react';
import { SectionHeader } from '../components/UI';
import { api } from '../lib/api';

const TYPE_LABEL = {
  'auth.login': 'Sign in',
  'auth.register': 'New teammate',
  'scenario.create': 'Scenario created',
  'scenario.update': 'Scenario updated',
  'scenario.delete': 'Scenario deleted',
  'comment.add': 'Comment added',
  'admin.reseed': 'Reseeded data',
};

export default function AuditLog() {
  const [entries, setEntries] = useState([]);
  const [filter, setFilter] = useState('');
  useEffect(() => { api.get('/audit').then((r) => setEntries(r.data)); }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  const filtered = entries.filter((e) =>
    !filter || e.type.includes(filter) || (e.user_name || '').toLowerCase().includes(filter.toLowerCase()) || (e.message || '').toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div className="space-y-8">
      <SectionHeader
        eyebrow="History"
        title="Every change, every edit, every sign-in"
        description="A single audit trail so the team can see exactly what happened and when."
        right={
          <input
            data-testid="audit-filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            placeholder="Filter by user, type, or message…"
            className="bg-white border border-indie-navy/20 px-3 py-2 text-sm min-w-[280px] focus:outline-none focus:border-indie-navy"
          />
        }
      />

      <div className="bg-white border-t-4 border-indie-navy">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-indie-navy text-indie-cream">
              <th className="text-left px-4 py-3 font-medium tracking-wider uppercase text-xs">When</th>
              <th className="text-left px-4 py-3 font-medium tracking-wider uppercase text-xs">Who</th>
              <th className="text-left px-4 py-3 font-medium tracking-wider uppercase text-xs">Type</th>
              <th className="text-left px-4 py-3 font-medium tracking-wider uppercase text-xs">What</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((e, i) => (
              <tr key={e.id} className={i % 2 === 0 ? 'bg-white' : 'bg-indie-cream'}>
                <td className="px-4 py-2.5 num-tabular text-indie-ink/70 whitespace-nowrap">{new Date(e.timestamp).toLocaleString()}</td>
                <td className="px-4 py-2.5">
                  <div className="font-medium text-indie-navy">{e.user_name}</div>
                  <div className="text-xs text-indie-ink/50">{e.user_email}</div>
                </td>
                <td className="px-4 py-2.5 text-indie-cobalt text-xs uppercase tracking-wider">{TYPE_LABEL[e.type] || e.type}</td>
                <td className="px-4 py-2.5 text-indie-ink/80">{e.message}</td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={4} className="px-4 py-10 text-center text-indie-ink/50">No history yet. Start editing a scenario to see entries appear here.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
